import { createWebHistory, createRouter } from "vue-router";
import Layout from "@/layout/index.vue";


export const constantRoutes = [
    {
        path: "/",
        component: Layout,
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('@/views/home/index.vue')
            },
            {
                path: '/dataConstruction',
                name: 'DataConstruction',
                component: () => import('@/views/dataConstruction/index.vue')  // 路由懒加载
            },
            {
                path: '/dataApplication',
                name: 'DataApplication',
                component: () => import('@/views/dataApplication/index.vue')
            },
            {
                path: '/aboutUs',
                name: 'AboutUs',
                component: () => import('@/views/aboutUs/index.vue')
            },

        ],
        redirect: '/home'
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404',
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes: constantRoutes,
});
export default router;
